const HUBSPOT_BASE_URL = 'https://meetings.hubspot.com';
export const RD_HELP_URL = `${HUBSPOT_BASE_URL}/ahmad-ibrahim`;
